import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCompanyGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      const pendingInvoices = JSON.parse(
        localStorage.getItem('lastSelectedPendingInvoices')
      );
      if (pendingInvoices) {
        this.router.navigateByUrl('/client-corner/home');
      }
      return !pendingInvoices;
    } else {
      return this.router.navigateByUrl('/login');
    }
  }
}
